import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getBranch } from './get-branch';

/** `PATCH /client/:cid/branches/:id {address, latitude, longitude}`. */
export const editBranchAddress = async (
  branch_id: string,
  address: string,
  location: any
): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/branches/${branch_id}`), {
    body: {
      address,
      latitude: location?.latitude ?? location?.lat,
      longitude: location?.longitude ?? location?.lng
    }
  });

  return getBranch(branch_id);
};
